interface DealerListingProps {
  vin: string;
  year: number;
  make: string;
  model: string;
  mileageUnformatted: number | null;
  priceUnformatted: number;
  vdpUrl: string;
  photoUrls: string[];
}

export type DealerListing = DealerListingProps;

export default function createDealerListing(props: DealerListingProps): DealerListing {
  return { ...props };
}
